/**
 * Layout the images section in the editProfile page
 */
import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../../shared/locales/no.json';
import ImageInput from './ImageInput';
import DraggableImage from '../DraggableImage';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import { upload, remove, reorder } from '../../actions/imageActions';
import { withRouter } from 'react-router-dom';

const TRANSITION_OPTIONS = {
    timeout: { enter: 500, exit: 300 },
    classNames: 'fade-in',
};

export class EditImages extends React.Component {
    static propTypes = {
        errorMsg: PropTypes.string,
        dispatch: PropTypes.func.isRequired,
        profileId: PropTypes.number,
        images: PropTypes.object,
        location: PropTypes.object.isRequired,
    };

    _swap(reordered, imageIndex, i2) {
        const tmp = reordered[imageIndex];
        reordered[imageIndex] = reordered[i2];
        reordered[i2] = tmp;
        return reordered;
    }

    /**
     * Takes a list of images, returns a list if image ids
     * with the image at @imageIndex swapped with its adjacent
     * left or right image
     */
    _reorder = (imageIndex, images, rightOrLeft) => {
        const end = images.length - 1;
        let swapIndex;

        if (rightOrLeft === 'right') {
            swapIndex = imageIndex === end ? 0 : imageIndex + 1;
        } else {
            swapIndex = imageIndex === 0 ? end : imageIndex - 1;
        }

        const reordered = images.map((i) => i.id);
        return this._swap(reordered, imageIndex, swapIndex);
    };

    onUpload = (profileId, file) => {
        this.props.dispatch(upload(profileId, file));
    };

    reorderImages = (leftOrRight, imageIndex) => {
        const reorderList = this._reorder(
            imageIndex,
            this.props.images.images,
            leftOrRight
        );
        this.props.dispatch(reorder(this.props.profileId, reorderList));
    };

    onDeleteClick = (img, e) => {
        e.preventDefault();
        this.props.dispatch(remove(this.props.profileId, img.id));
    };

    /**
     * Called by draggable Image. Will swap two images.
     */
    swapImages = (id, afterId) => {
        const reorderList = this.props.images.images.map((img) => img.id);
        const index1 = this.props.images.images.findIndex(
            (img) => img.id === id
        );
        const index2 = this.props.images.images.findIndex(
            (img) => img.id === afterId
        );

        reorderList[index1] = this.props.images.images[index2].id;
        reorderList[index2] = this.props.images.images[index1].id;

        this.props.dispatch(reorder(this.props.profileId, reorderList));
    };

    renderImages() {
        const self = this;

        return this.props.images.images.map((img, i) => (
            <CSSTransition {...TRANSITION_OPTIONS} key={`img-thmb-${img.id}`}>
                <div className="grid__unit">
                    <DraggableImage
                        className="panel transitionable"
                        editHref={`${this.props.location.pathname}/image/${img.id}${this.props.location.search}`}
                        id={img.id}
                        imageIndex={i}
                        img={img}
                        onDeleteClick={self.onDeleteClick.bind(self, img)}
                        reorderImages={self.reorderImages}
                        swapImages={self.swapImages}
                    />
                </div>
            </CSSTransition>
        ));
    }

    render() {
        return (
            <DndProvider backend={HTML5Backend}>
                <section>
                    <div className="panel">
                        <h2>{i18n.images.images}</h2>
                    </div>
                    <TransitionGroup
                        className="grid t-grid grid--cols1to2"
                        component="div"
                    >
                        {this.renderImages()}
                        <CSSTransition {...TRANSITION_OPTIONS}>
                            <div className="panel">
                                <ImageInput
                                    errorMsg={this.props.errorMsg}
                                    onUpload={this.onUpload}
                                    profileId={this.props.profileId}
                                />
                            </div>
                        </CSSTransition>
                    </TransitionGroup>
                </section>
            </DndProvider>
        );
    }
}

export default connect(() => ({}))(withRouter(EditImages));
